import { ReactNode } from 'react'
import { Box, SxProps } from '@hermes/web-components'

interface ConditionalRenderBoxProps {
  children: ReactNode
  isOpen: boolean
  isClientSide?: boolean
  sx?: SxProps
}

const ConditionalRenderBox = ({ children, isOpen, isClientSide, sx }: ConditionalRenderBoxProps) =>
  isClientSide ? (
    <Box sx={sx}>{isOpen && children}</Box>
  ) : (
    <Box
      sx={{
        display: isOpen ? 'block' : 'none',
        ...sx
      }}
    >
      {children}
    </Box>
  )

export default ConditionalRenderBox
